import { ReactComponent as EyeClosed } from "assets/svg/outline-eye-closed.svg";
import { ReactComponent as EyeOpen } from "assets/svg/outline-eye-open.svg";
import "./reset-password-modal.scss";

const EyeIcon = ({ showPassword, onClick }) => {
  return (
    <div className="showHidePasswordIcon" onClick={onClick}>
      {showPassword ? <EyeClosed /> : <EyeOpen />}
    </div>
  );
};

export default EyeIcon;
